import { StyledSpinner } from '@tryhackme/thm-ui-components';
import { useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { displayToast } from 'src/common/helpers/display-toast';
import { useGetUserQuery } from 'src/common/slices';
import { useFollowUserByUsernameMutation } from 'src/features/dashboard/components/user-connections/user-connections.slice';
import * as Styled from './invite-page.styles';
export const INVITE_LOCAL_STORAGE_KEY = 'invitedByUsername';
export const InvitePage = () => {
  const {
    username
  } = useParams();
  const navigate = useNavigate();
  const hasRunRef = useRef(false);
  const {
    data: userQueryData,
    isLoading: isUserLoading
  } = useGetUserQuery();
  const [followUser] = useFollowUserByUsernameMutation();
  const isLoggedIn = !!userQueryData?.data?.user;
  useEffect(() => {
    if (hasRunRef.current) return;
    if (isUserLoading) return;
    const trimmedUsername = username?.trim();
    if (!trimmedUsername) return;
    const handleInvite = async () => {
      if (!isLoggedIn) {
        try {
          localStorage.setItem(INVITE_LOCAL_STORAGE_KEY, trimmedUsername);
        } catch (error) {
          console.error('Failed to store invite username:', error);
        }
        return;
      }
      await followUser(trimmedUsername).unwrap().then(() => displayToast('success', `You are now following ${trimmedUsername}!`)).catch(error => {
        const errorMessage = error?.message ?? error?.data?.message ?? '';
        if (errorMessage.includes('You already follow this user')) {
          displayToast('info', 'You already follow this user');
        } else {
          displayToast('error', 'Something went wrong. Please try again.');
        }
      });
    };
    hasRunRef.current = true;
    handleInvite().finally(() => navigate('/'));
  }, [username, navigate, isLoggedIn, followUser, isUserLoading]);
  return <Styled.Container data-sentry-element="unknown" data-sentry-component="InvitePage" data-sentry-source-file="invite-page.tsx">
      <Styled.LoadingContent data-sentry-element="unknown" data-sentry-source-file="invite-page.tsx">
        <StyledSpinner color={'#000000'} size="3rem" data-testid="invite-loading-spinner" data-sentry-element="StyledSpinner" data-sentry-source-file="invite-page.tsx" />
      </Styled.LoadingContent>
    </Styled.Container>;
};